import script from "./payment_method.vue?vue&type=script&setup=true&lang=js"
export * from "./payment_method.vue?vue&type=script&setup=true&lang=js"

import "./payment_method.vue?vue&type=style&index=0&id=fd023246&lang=less"

const __exports__ = script;

export default __exports__